import { gql } from "@apollo/client";
import { useCloudClient } from "@/shell-handle/ShellHostProvider";
import { createAuthApi } from "@/shell-handle/auth";

const LOGOUT_USER = gql`
  mutation LogoutUser($email: String!) {
    logoutUser(email: $email)
  }
`;

type LogoutFn = (args?: { variables?: { email?: string } }) => Promise<unknown>;

type UseLogoutHook = (opts?: {
  onCompleted?: () => void;
  onError?: (e: unknown) => void;
}) => [LogoutFn, { loading: boolean }];

export const useLogoutUserMutation: UseLogoutHook = (opts) => {
  const cloudClient = useCloudClient();

  const fire: LogoutFn = async (args) => {
    const email = args?.variables?.email;
    if (cloudClient && email) {
      try {
        await cloudClient.mutate({
          mutation: LOGOUT_USER,
          variables: { email },
        });
      } catch (e) {
        console.warn("[shell] logoutUser mutation failed:", e);
      }
    }
    try {
      // This is the sign-out that actually ends the session — it runs before
      // onCompleted. It must go through the shell's auth api so the Hub event is
      // classified as deliberate and no returnTo is left for the next user.
      await createAuthApi().signOut();
      opts?.onCompleted?.();
    } catch (e) {
      opts?.onError?.(e);
    }
  };
  return [fire, { loading: false }];
};
